var exports = {
  "P": "NewRulesetButton__uRRRlC",
  "z": "BPConversionBanner__SXP_eX",
};

module.exports = exports;
